import React from 'react';
import { SvgIcon, SvgIconProps, Tooltip } from '@mui/material';
import { Warning, FavoriteOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

// TODO: Replace with generated types once schema is updated
export enum GqlScoreType {
  RISK = 'RISK',
  WELLNESS = 'WELLNESS'
}

interface ScoreTypeIconProps extends Omit<SvgIconProps, 'children'> {
  scoreType: GqlScoreType;
  showTooltip?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const ScoreTypeIcon: React.FC<ScoreTypeIconProps> = ({
  scoreType,
  showTooltip = false,
  size = 'medium',
  ...iconProps
}) => {
  const { t } = useTranslation();

  const getIconComponent = () => {
    return scoreType === GqlScoreType.RISK ? Warning : FavoriteOutlined;
  };

  const getColor = () => {
    if (iconProps.color) return iconProps.color;
    return scoreType === GqlScoreType.RISK ? 'warning' : 'success';
  };

  const getTooltipText = () => {
    return scoreType === GqlScoreType.RISK
      ? t('scoreType.riskDescription', 'Risk assessment metric')
      : t('scoreType.wellnessDescription', 'Wellness indicator metric');
  };

  const getFontSize = () => {
    switch (size) {
      case 'small': return 'small';
      case 'large': return 'large';
      default: return 'medium';
    }
  };

  const IconComponent = getIconComponent();
  
  const icon = (
    <IconComponent
      {...iconProps}
      color={getColor() as any}
      fontSize={getFontSize() as any}
    />
  );

  if (showTooltip) {
    return (
      <Tooltip title={getTooltipText()} arrow>
        {icon}
      </Tooltip>
    );
  }

  return icon;
};

export default ScoreTypeIcon;